import React, { useState } from "react";
import {
  Box,
  Heading,
  Text,
  CheckBox,
  FormField,
  Anchor,
  Button,
} from "grommet";
import { useNavigate } from "react-router-dom";
import { useQuizContext } from "../../contexts/QuizContext"; // Import QuizContext
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
export const QuizSummary = ({
  difficulty,
  numberOfQuestions,
  onModify,
  onStart,
}) => {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [contactTermsAccepted, setContactTermsAccepted] = useState(false);

  // const handleStart = async () => {
  //   allowQuizAttempt(); // Allow access to the attempt-quiz page
  //   localStorage.removeItem("localQuizProgress");
  //
  //   try {
  //      // Map difficulty to required format ("0", "1", "2")
  //     const difficultyMapping = {
  //       Easy: "0",
  //       Intermediate: "1",
  //       Expert: "2",
  //     };

  //     // Prepare the data for the POST request
  //     const data = {
  //       user_id: user_id,
  //       difficulty: difficultyMapping[difficulty], // Use the corrected difficulty mapping
  //       query_count: numberOfQuestions,
  //     };

  //     // Send POST request to the backend to start the assessment
  //     const response = await axios.post("/api/start-assessment", data); // Replace with your backend endpoint

  //     if (response.status === 200) {
  //       const assessmentId = response.data.assessment_id; // Get assessment_id from response

  //       // Redirect to the quiz page with the assessment_id in the URL
  //       if (assessmentId) {
  //         navigate(`/quiz/${assessmentId}`, { state: { numberOfQuestions } });
  //       }
  //     } else {
  //       alert("Failed to start the assessment.");
  //     }
  //   } catch (error) {
  //     console.error("Error starting the quiz:", error);
  //     alert("An error occurred while starting the assessment.");
  //   }
  // };

  return (
    <Box pad="medium" gap="medium" align="center">
      <Heading level="2">Start your assessment</Heading>

      {/* Assessment settings box */}
      <Box
        pad="medium"
        border={{ color: "brand", size: "small" }}
        round="small"
        width="large"
      >
        <Text>
          <b>Assessment settings</b>
        </Text>
        <Text>Number of questions: {numberOfQuestions}</Text>
        <Text>Duration: {numberOfQuestions} minutes</Text>
      </Box>

      {/* Important Information box */}
      <Box
        pad="medium"
        background="light-2" // Subtle background for emphasis
        round="small"
        width="large"
        border={{ color: "brand", size: "small" }} // Border to highlight this section
      >
        <Heading level="3">
          Important information before starting your assessment
        </Heading>
        <Text margin={{ top: "small" }}>
          <b>1. Be honest about your skills:</b> Please answer the questions
          truthfully based on your current knowledge. This helps us generate
          accurate and useful insights for your development.
        </Text>
        <Text margin={{ top: "small" }}>
          <b>2. Personalized recommendations:</b> Based on your responses, you
          will receive tailored learning paths that match your current skill
          level and areas for improvement.
        </Text>
        <Text margin={{ top: "small" }}>
          <b>3. Focus on growth:</b> The assessment is meant to guide you in
          identifying areas where you can improve. It is not a test, but rather
          a tool for personal and professional development.
        </Text>
        <Text margin={{ top: "small" }}>
          <b>4. Your privacy matters:</b> All of your responses will be kept
          confidential and will only be used for the purpose of generating
          recommendations. Your data will not be shared with third parties.
        </Text>
      </Box>

      {/* Action buttons */}
      <Box
        direction="row"
        gap="medium"
        justify="center"
        margin={{ top: "medium" }}
      >
        <Button label="Go back" onClick={onModify} />
        <Button
          label="Start your assessment"
          onClick={onStart}
          primary
          // disabled={!termsAccepted}
        />
      </Box>
    </Box>
  );
};
